<div class="slideout-content">
  <!-- Modal to add or edit product starts-->
  <div class="modalsd modal-slide-in sdfade product-modal" id="modals-slide-in">
    <div class="modal-dialog"
    [ngStyle]="
    isSmallDisplay?{'width': '26rem'} : {'width': '60%'}"
    >
      
      <form class="add-product modal-content pt-0" (ngSubmit)="(productForm.form.valid)" #productForm="ngForm">
        <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="toggleSidebar('product-sidebar')"
        >
          ×
        </button>
        <div class="modal-header mb-1">
          <h5 class="modal-title" *ngIf="currentProduct.id != null" id="modalLabel">Edit Plan</h5>
          <h5 class="modal-title" *ngIf="currentProduct.id == null" id="modalLabel">New Plan</h5>
        </div>

        <div class="modal-body flex-grow-1">
          
          <ul ngbNav #navWithIcons="ngbNav" class="nav-tabs" style="place-content: center;">
            <li ngbNavItem [ngbNavItem]="1">
              <a ngbNavLink>Profile</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="form-label" for="product-sidebar-name">Name</label>
                      <input
                        type="text"
                        id="product-sidebar-name"
                        class="form-control dt-name"
                        placeholder="Plan name"
                        aria-describedby="product-sidebar-name"
                        name="product-name"
                        [(ngModel)]="currentProduct.title"
                        [class.error]="productForm.submitted && FNameRef.invalid"
                        #FNameRef="ngModel"
                        required
                      />
                      <span *ngIf="productForm.submitted && FNameRef.invalid" class="invalid-form">
                        <small class="form-text text-danger" *ngIf="FNameRef.errors.required">This field is required!</small>
                      </span>
                    </div>   

                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Locations</label>
                      <!-- Select Multi with Icon -->
                      <ng-select
                        [items]="locations"
                        [multiple]="true"
                        bindLabel="locationName"
                        bindValue="id"
                        [closeOnSelect]="false"
                        name="product-locations"
                        [(ngModel)]="currentProduct.location_id"
                      >
                        <ng-template ng-label-tmp let-item="item"  let-clear="clear">
                          <span class="ng-value-label" *ngIf="item.locationLogo">
                            <img *ngIf="item.locationLogo != ''" [src]="item.locationLogo" alt="Avatar" height="20" width="20" />
                            <img *ngIf="item.locationLogo == ''" src="assets/images/profile/user-uploads/location-00.png" alt="Avatar" height="20" width="20" />

                            {{ item.locationName }}</span
                          >
                          <span class="ng-value-label" *ngIf="!item.locationLogo">
                            Invalid location ({{item.id}})
                          </span>
                          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                        </ng-template>
    
                        <ng-template ng-header-tmp>
                          <a
                            (click)="selectAll('product')"
                            class="btn btn-flat-primary btn-sm"
                          >
                            Select all
                          </a>
                          <a
                            (click)="unselectAll('product')"
                            class="btn btn-flat-primary btn-sm"
                          >
                            Unselect all
                         </a>
                        </ng-template>
    
                        <ng-template ng-option-tmp let-item="item">
                          <img *ngIf="item.locationLogo != ''" [src]="item.locationLogo" alt="Avatar" height="20" width="20" />
                          <img *ngIf="item.locationLogo == ''" src="assets/images/profile/user-uploads/location-00.png" alt="Avatar" height="20" width="20" />
                          {{ item.locationName }}
                        </ng-template>
                      </ng-select>
                      <!--/ Select Multi with Icon -->
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label" for="product-sidebar-description">Description</label>
                      <fieldset class="form-label-group mb-0">
                        <textarea
                          [(ngModel)]="currentProduct.description"
                          name="product-sidebar-description"
                          #textLength
                          [maxlength]="500"
                          class="form-control dt-description"
                          placeholder="Plan description"
                          id="product-sidebar-description"
                          rows="3"
                          #FDescriptionRef="ngModel"
                          required
    
                        ></textarea>
                        <span *ngIf="productForm.submitted && FDescriptionRef.invalid" class="invalid-form">
                          <small class="form-text text-danger" *ngIf="FDescriptionRef.errors.required">This field is required!</small>
                        </span>
                      </fieldset>
                      <small class="textarea-counter-value float-right"
                        ><span *ngIf="textLength" class="char-count">{{ textLength.value.length }}</span>
                        <span *ngIf="!textLength" class="char-count">0 </span> / 500
                      </small>
                    </div>  
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="form-group mb-1">
                      <div class="custom-control custom-checkbox" >
                        <input type="checkbox" class="custom-control-input" (click)="switchFee('setupFee',null)" id="product-sidebar-setup_fee" [checked]=" currentProduct.setupFee > 0"/>
                        <label class="custom-control-label form-label" for="product-sidebar-setup_fee">Setup Fee</label>
                      </div>
                      <input type="number" min="0" step="0.1" name="priceValue1" #FPrice1Ref="ngModel" [(ngModel)]="currentProduct.setupFee" name="setupFee" placeholder="0.00" aria-label="Amount (to the nearest dollar)" class="form-control">
                    </div>
                    <div class="form-group">
                      <label class="form-label" for="product-sidebar-startDate">Start Date</label>
                      <div class="input-group">
                       
                        <input
                          type="date"
                          class="form-control"
                          aria-describedby="startDate"
                          id="product-sidebar-startDate"
                          name="product-sidebar-startDate" 
                          [value]="currentProduct.startDate"
                          disabled
                          [(ngModel)]="currentProduct.startDate"
                          [class.error]="productForm.submitted && startDate.invalid"
                          required
                          #startDate="ngModel"

                        />
                      
                      </div>
                      <div *ngIf="submitted && f.startDate.errors" class="invalid-feedback" for="startDate"> 
                        <div *ngIf="f.startDate.errors.required">Start date is required</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="form-label" for="product-sidebar-endDate">End Date</label>
                      <div class="input-group">
                        <input
                          type="date"
                          class="form-control"
                          aria-describedby="endDate"
                          id="product-sidebar-endDate"
                          name="product-sidebar-endDate" 
                          [value]="currentProduct.endDate"                          
                          [(ngModel)]="currentProduct.endDate"
                          #endDate="ngModel"
                          [class.error]="productForm.submitted && endDate.invalid"
                          
                        />
                      </div>  
                      <div *ngIf="submitted && f.endDate.errors" class="invalid-feedback" for="endDate"> 
                        <div *ngIf="f.endDate.errors.required">End date is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-12">

                    <div class="form-group">
                      <label class="form-label">Price and Frequency</label>
                      <div class="row" *ngIf="currentProduct">
                        <div class="col-lg-3 col-md-6 col-sm-12" style="text-align-last: center;">
                          <div class="custom-control custom-switch custom-switch">
                            <input type="checkbox" class="custom-control-input" id="product-sidebar-priceSwitch1" [checked]="currentProduct.pricing.weekly > 0" (click)="switchFee('pricing', 'weekly')" />
                            <label class="custom-control-label" for="product-sidebar-priceSwitch1">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                          <h5>Weekly</h5>
                          <input type="number" min="0" step="0.1" name="priceValue1" #FPrice1Ref="ngModel" [(ngModel)]="currentProduct.pricing.weekly" placeholder="0.00" aria-label="Amount (to the nearest dollar)" class="form-control">
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12" style="text-align-last: center;">
                          <div class="custom-control custom-switch custom-switch" >
                            <input type="checkbox" class="custom-control-input" id="product-sidebar-priceSwitch2" [checked]="currentProduct.pricing.fortnightly > 0" (click)="switchFee('pricing', 'fortnightly')"/>
                            <label class="custom-control-label" for="product-sidebar-priceSwitch2">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                          <h5>Fortnightly</h5>
                          <input type="number" min="0" step="0.1" name="priceValue2" #FPrice2Ref="ngModel" [(ngModel)]="currentProduct.pricing.fortnightly" placeholder="0.00" aria-label="Amount (to the nearest dollar)" class="form-control">
                        </div>
                        
                        <div class="col-lg-3 col-md-6 col-sm-12" style="text-align-last: center;">
                          <div class="custom-control custom-switch custom-switch" >
                            <input type="checkbox" class="custom-control-input" id="product-sidebar-priceSwitch3" [checked]="currentProduct.pricing.monthly > 0" (click)="switchFee('pricing', 'monthly')"/>
                            <label class="custom-control-label" for="product-sidebar-priceSwitch3">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                          <h5>Monthly</h5>
                          <input type="number" min="0" step="0.1" name="priceValue3" #FPrice3Ref="ngModel" [(ngModel)]="currentProduct.pricing.monthly" placeholder="0.00" aria-label="Amount (to the nearest dollar)" class="form-control">
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12" style="text-align-last: center;">
                          <div class="custom-control custom-switch custom-switch" >
                            <input type="checkbox" class="custom-control-input" id="product-sidebar-priceSwitch4" [checked]="currentProduct.pricing.annually > 0" (click)="switchFee('pricing', 'annually')"/>
                            <label class="custom-control-label" for="product-sidebar-priceSwitch4">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                          <h5>Annually</h5>
                          <input type="number" min="0" step="0.1" name="priceValue4" #FPrice4Ref="ngModel" [(ngModel)]="currentProduct.pricing.annually" placeholder="0.00" aria-label="Amount (to the nearest dollar)" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </ng-template>
            </li>
       
            <li ngbNavItem [ngbNavItem]="2">
              <a ngbNavLink> Benefits</a>
              <ng-template ngbNavContent>
                <div class="row" id="table-hover-row">
                  <div class="col-lg-5 col-md-5 col-sm-12">
                    <label class="form-label">Included Services and Benefits</label>
                    <div class="card">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>Service/Benefit</th>
                              <th>Qty/Yr</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let treatment of currentProduct.treatment; let i = index;" (click)="modalOpenCodes(modalBD2, treatment, i)">
                              <td>
                                <span class="font-weight-bold">{{treatment.title}}</span>
                              </td>
                              <td>{{treatment.annualQuantity}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="card-body" style="text-align: center;">
                        <button type="button" class="btn btn-icon btn-icon rounded-circle btn-primary" (click)="addNewTreatment()" rippleEffect>
                          <span [data-feather]="'plus'"></span></button
                        >
                      </div>
                      
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-7 col-sm-12">
                    <label class="form-label">Discounts on services and Products</label>
                    <div class="card">
                      <div class="card-body">
                        <div class="form-group row" style="text-align: -webkit-center;">
                          <div class="col-6">
                            <p>Apply discount to all categories (%) </p> 
                          </div>
                          <div class="col-6 center">
                            <core-touchspin 
                              (onChange)="editingData($event, 'discount')"
                              [numberValue]="discountValue" 
                              [stepValue]="1" 
                              [minValue]="0" 
                              [maxValue]="100"
                            >
                            </core-touchspin>
                            <button type="submit" class="btn btn-primary" (click)="setDiscount()" rippleEffect>
                              Apply to all
                            </button>

                          </div>
                          <!-- touchspin min-max -->
              
                        </div>   
                
                        
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body row">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th>Category</th>
                                <th>Discount(%)</th>
                                <th>Include</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let category of currentProduct.servicesProductsDiscounts; let i = index;">
                                <td>
                                  <span class="font-weight-bold" >{{category.name}}</span>
                                </td>
                                <td>
                                  <span class="font-weight-bold" >{{category.discount}}</span>
                                </td>
                                <td>
                                  <div class="custom-control custom-switch custom-switch row" style="z-index: 0;" >
                                    <input type="checkbox" class="custom-control-input" id="discountOfferCategory{{i}}" (click)="switchOffer(i, modalBD3)" [checked]="category.offer" />
                                    <label class="custom-control-label" for="discountOfferCategory{{i}}">
                                      <span class="switch-icon-left"><i data-feather="check"></i></span>
                                      <span class="switch-icon-right"><i data-feather="x"></i></span>
                                    </label>
                                    <a [ngClass]="{
                                      'text-primary': category.offer === true,
                                      'text-secondary hidden': category.offer === false
                                      }"
                                      (click)="modalOpenDiscounts(modalBD3, category)"
                                    >
                                      <i data-feather="edit"></i> 
                                    </a>
                                  </div>                          
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        </div>
                    </div>

                  </div>
                </div>
              </ng-template>
            </li>
            <li ngbNavItem [ngbNavItem]="3">
              <a ngbNavLink>Terms</a>
              <ng-template ngbNavContent>
                <div class="row" id="table-hover-row">
                  <div class="col-lg-5 col-md-5 col-sm-12">
                    <div>
                      <label class="form-label mt-1">Membership lock-in period (Months)</label>
                      <core-touchspin 
                        (onChange)="editingTerm($event, 'minPeriod')"
                        [numberValue]="currentProduct.minPeriod" 
                        [stepValue]="1" 
                        [minValue]="0" 
                        [maxValue]="24"
                      >
                      </core-touchspin>
                    </div>
                    <div>
                      <label class="form-label mt-1">Age from:</label>
                    <core-touchspin 
                      (onChange)="editingTerm($event, 'ageFrom')"
                      [numberValue]="currentProduct.ageFrom" 
                      [stepValue]="1" 
                      [minValue]="0" 
                      [maxValue]="120"
                    >
                    </core-touchspin>
                    </div>
                      
                    <div>
                      <label class="form-label mt-1">Age To:</label>
                    <core-touchspin 
                      (onChange)="editingTerm($event, 'ageTo')"
                      [numberValue]="currentProduct.ageTo" 
                      [stepValue]="1" 
                      [minValue]="0" 
                      [maxValue]="120"
                    >
                    </core-touchspin>
                    </div>

                    <div>
                      <button type="button" class="btn round" (click)="switchLimit('ageLimit')"
                      [ngClass]="{ 
                        'btn-primary': currentProduct.ageTo == 0,
                        'btn-outline-secondary': currentProduct.ageTo > 0}" 
                        rippleEffect>No age limits</button>
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-7 col-sm-12">
                    <div class="form-group">

                      <label class="form-label">Specific Terms and Conditions</label>
                      <fieldset class="form-label-group mb-0">
                        <textarea
                          [(ngModel)]="currentProduct.generalTerms[0].content"
                          name="product-sidebar-generalTerms"
                          #textLength
                          [maxlength]="500"
                          class="form-control dt-description"
                          placeholder="Plan description"
                          id="product-sidebar-generalTerms"
                          rows="3"
                          #FTextareaRef="ngModel" 
                          [ngModelOptions]="{standalone: true}"
                        ></textarea>
                      </fieldset>
                      <small class="textarea-counter-value float-right"
                        ><span *ngIf="textLength" class="char-count">{{ textLength.value.length }}</span>
                        <span *ngIf="!textLength" class="char-count">0 </span> / 500
                      </small>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>

          </ul>
          <div [ngbNavOutlet]="navWithIcons" class="mt-2"></div>    
        </div>
        <div class="modal-footer row" style="position: fixed; bottom: 0px; width: -webkit-fill-available; background-color: #f8f8f8d4; margin: 0px; padding: 5px;">
          <div *ngIf="!alertClose" class="col-12" style="padding: 12px;">
            
            <ngb-alert [type]="'danger'" (closed)="alertClose = !alertClose">
              <h4 class="alert-heading">Error</h4>
              <div class="alert-body">
                {{alert}}
                <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </ngb-alert>
          </div>
          <div class="col-12" *ngIf="!loadingButton">
            <button type="submit" class="btn btn-primary mr-1" (click)="submit(productForm)" rippleEffect>
              Save
            </button>
            <button type="reset" class="btn btn-outline-secondary" (click)="toggleSidebar('product-sidebar')" >Cancel</button>
            <button type="button" class="btn btn-icon btn-icon rounded-circle btn-danger" style="position:absolute; right :15px;" *ngIf="currentProduct.status == 'inactive' && currentProduct.memberCounter == 0" (click)="modalOpenDeleteItem(modalDeleteProduct)" rippleEffect>
              <span [data-feather]="'trash-2'"></span></button
            >
          </div>
          <div class="col-12" *ngIf="loadingButton">
            <button class="btn btn-outline-primary" type="button" disabled rippleEffect>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="ml-25 align-middle">Saving...</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Modal to add edit product Ends-->
</div>

<!-- Modal Edit Included Treatments -->
 <ng-template #modalBD2 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel4">Edit Included Treatments</h4>
    <!-- <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-12">
        <div class="form-group">
          <label class="form-label" for="product-sidebar-title">Title</label>
          <input
            type="text"
            id="product-sidebar-title"
            class="form-control dt-title"
            placeholder="Plan title"
            aria-describedby="product-sidebar-title2"
            name="product-title"
            [(ngModel)]="currentTreatment.title"
            [class.error]="productForm.submitted && FTreatTitleRef.invalid"
            #FTreatTitleRef="ngModel"
            required
          />
          <span *ngIf="productForm.submitted && FTreatTitleRef.invalid" class="invalid-form">
            <small class="form-text text-danger" *ngIf="FTreatTitleRef.errors.required">This field is required!</small>
          </span>
        </div>   
        <div class="form-group">
          <label class="form-label" for="product-sidebar-title">Annual quantity: </label> 
          <!-- touchspin min-max -->
          <core-touchspin 
            (onChange)="editingData($event, 'annualQuantity')"
            [numberValue]="currentTreatment.annualQuantity" 
            [stepValue]="1" 
            [minValue]="0" 
            [maxValue]="24"
          >
          </core-touchspin>
          <button type="button" class="btn round" (click)="switchLimit('annualQuantity')"
          [ngClass]="{ 
            'btn-primary': currentTreatment.annualQuantity == 0,
            'btn-outline-secondary': currentTreatment.annualQuantity > 0}" 
            rippleEffect>Unlimited</button>
        </div>   
        <!-- <div class="form-group">
          <label class="form-label" for="product-sidebar-title">Score (Pts): </label> 
          
          <core-touchspin 
            (onChange)="editingData($event, 'score')"
            [numberValue]="currentTreatment.score" 
            [stepValue]="50" 
            [minValue]="0" 
            [maxValue]="1000"
          >
          </core-touchspin>
        </div>    -->
  
        <div class="form-group">
          <label class="form-label" for="product-sidebar-title">Waiting Period (Months): </label> 
          
          <!-- touchspin min-max -->
          <core-touchspin 
            (onChange)="editingData($event, 'waitingPeriod')"
            [numberValue]="currentTreatment.waitingPeriod" 
            [stepValue]="1" 
            [minValue]="0" 
            [maxValue]="24"
          >
          </core-touchspin>
        </div>   

      </div>
      <div class="col-lg-6 col-md-6 col-12">
        <div class="form-group">
          <label>Procedures</label>
        
          <!-- Select Multi with Icon -->
          <ng-select
            [items]="(rows.data | filter: currentTreatment['category']:'category')"
            [multiple]="true"
            bindLabel="procedure"
            bindValue="code"
            [closeOnSelect]="false"
            name="procedures"
            [(ngModel)]="currentTreatment.procedures"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label"
                ><small>{{ item.code }}</small> {{ item.procedure }}</span
              >
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </ng-template>

            <!-- <ng-template ng-header-tmp>
              <a
                (click)="selectAll('treatment')"
                class="btn btn-flat-primary btn-sm"
              >
                Select all
              </a>
              <a
                (click)="unselectAll('treatment')"
                class="btn btn-flat-primary btn-sm"
              >
                Unselect all
             </a>
            </ng-template> -->

            <ng-template ng-option-tmp let-item="item">
              <small>{{ item.code }}</small> {{ item.procedure }}
            </ng-template>
          </ng-select>
          <!--/ Select Multi with Icon -->
        </div>
        <div class="form-group">
          <label class="form-label" for="product-sidebar-specificTermsConditions">Specific Terms and Conditions</label>
          <fieldset class="form-label-group mb-0">
            <textarea
              [(ngModel)]="currentTreatment.specificTermsConditions"
              name="product-sidebar-specificTermsConditions"
              #textLength
              [maxlength]="500"
              class="form-control dt-specificTermsConditions"
              id="product-sidebar-specificTermsConditions"
              rows="3"
              #FspecificTermsConditionsRef="ngModel"
              required
  
            ></textarea>
            <!-- <span *ngIf="productForm.submitted && FspecificTermsConditionsRef.invalid" class="invalid-form">
              <small class="form-text text-danger" *ngIf="FspecificTermsConditionsRef.errors.required">This field is required!</small>
            </span> -->
          </fieldset>
          <small class="textarea-counter-value float-right"
            ><span *ngIf="textLength" class="char-count">{{ textLength.value.length }}</span>
            <span *ngIf="!textLength" class="char-count">0 </span> / 500
          </small>
        </div>  
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="this.modalService.dismissAll('ok');" rippleEffect>
      Ok
    </button>
    <button type="button" class="btn btn-icon btn-icon rounded-circle btn-danger" style="position:absolute; left :15px;" (click)="modalOpenDeleteItem(modalDeleteTreatment)" rippleEffect>
      <span [data-feather]="'trash-2'"></span></button
    >    
  </div>
</ng-template>
<!-- / Modal Edit Included Treatments -->
<!-- Modal Edit Discount Offer -->
<ng-template #modalBD3 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel4">Edit Discount Offer</h4>
    <!-- <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body row" tabindex="0" ngbAutofocus>

    <div class="col-lg-6 col-md-6 col-sm-12">
      <div class="form-group">
        <label class="form-label" for="product-sidebar-category">Category</label>
        <input
          type="text"
          id="product-sidebar-category"
          class="form-control dt-category"
          placeholder="Discount category"
          aria-describedby="product-sidebar-category2"
          name="discount-name"
          [disabled] = "true"
          [(ngModel)]="currentDiscount.name"
        />
      </div>   
      <div class="form-group">
        <label class="form-label" for="product-sidebar-category">Discount(%):</label>
        <core-touchspin 
          (onChange)="editingDiscount($event, 'discount')"
          [numberValue]="currentDiscount.discount" 
          [stepValue]="1" 
          [minValue]="0" 
          [maxValue]="100"
        >
        </core-touchspin>
      </div>
      <!-- <div class="form-group">
        <label class="form-label" for="product-sidebar-score">Score (Pts):</label>
        <core-touchspin 
        (onChange)="editingDiscount($event, 'score')"
        [numberValue]="currentDiscount.score" 
        [stepValue]="50" 
        [minValue]="0" 
        [maxValue]="1000"
      >
      </core-touchspin>

      </div>   -->

    </div>
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div class="form-group">
        <label class="form-label" for="product-sidebar-currentDiscountTerms">Specific Terms and Conditions</label>
        <fieldset class="form-label-group mb-0">
          <textarea
            [(ngModel)]="currentDiscount.terms"
            name="product-sidebar-currentDiscountTerms"
            #textLength
            [maxlength]="500"
            class="form-control dt-description"
            placeholder="Plan description"
            id="product-sidebar-currentDiscountTerms"
            rows="3"
            #FDescriptionRef="ngModel"
            required

          ></textarea>
          <span *ngIf="productForm.submitted && FDescriptionRef.invalid" class="invalid-form">
            <small class="form-text text-danger" *ngIf="FDescriptionRef.errors.required">This field is required!</small>
          </span>
        </fieldset>
        <small class="textarea-counter-value float-right"
          ><span *ngIf="textLength" class="char-count">{{ textLength.value.length }}</span>
          <span *ngIf="!textLength" class="char-count">0 </span> / 500
        </small>
      </div>  
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="this.modalService.dismissAll('ok');" rippleEffect>
      Ok
    </button>
  </div>
</ng-template>
<!-- / Modal Edit Discount Offer -->
<!-- Modal Delete Item -->
<ng-template #modalDeleteProduct let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel4">Delete</h4>
  </div>
  <div class="modal-body">
    <p>Do you really want to delete this Membership Plan permanently?</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="deleteItem('product')" rippleEffect>
        <span>YES</span></button
      >
      <button type="button" class="btn btn-danger" (click)="modal.close('Accept click')" rippleEffect>
        <span>NO</span></button
      >
  </div>
</ng-template>
<!-- / Modal Delete Item -->
<!-- Modal Delete Item -->
<ng-template #modalDeleteTreatment let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel4">Delete</h4>
  </div>
  <div class="modal-body">
    <p>Do you really want to delete this Treatment permanently?</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="deleteItem('treatment')" rippleEffect>
        <span>YES</span></button
      >
      <button type="button" class="btn btn-danger" (click)="modal.close('Accept click')" rippleEffect>
        <span>NO</span></button
      >
  </div>
</ng-template>
<!-- / Modal Delete Item -->
<!-- Modal Delete Item -->
<ng-template #modalDeleteTerm let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel4">Delete</h4>
  </div>
  <div class="modal-body">
    <p>Do you really want to delete this Term permanently?</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="deleteItem('term')" rippleEffect>
        <span>YES</span></button
      >
      <button type="button" class="btn btn-danger" (click)="modal.close('Accept click')" rippleEffect>
        <span>NO</span></button
      >
  </div>
</ng-template>
<!-- / Modal Delete Item -->
